
export class ApiService {
  constructor(url) {
    this.baseUrl = url
  }

  // 获取列表数据.需要分页
  list(query, _basicId) {
    let url = this.baseUrl + '/list'
    if (_basicId) {
      url += '/' + _basicId
    }
    return custemRequest({
      url: url,
      method: 'get',
      params: query
    })
  }

  // 获取列表数据.不需要分页
  all(query) {
    return custemRequest({
      url: this.baseUrl + '/all',
      method: 'get',
      params: query
    })
  }

  tree(query) {
    return custemRequest({
      url: this.baseUrl + '/tree',
      method: 'get',
      params: query
    })
  }

  // 新增数据
  create(data, _basicId) {
    let url = this.baseUrl
    if (_basicId) {
      url += '/' + _basicId
    }
    return custemRequest({
      url: url,
      method: 'post',
      data: data
    })
  }



  // 修改数据
  update(id, data, _basicId) {
    let url = this.baseUrl + '/' + id
    if (_basicId) {
      url = this.baseUrl + '/' + _basicId + '/' + id
    }
    return custemRequest({
      url: url,
      method: 'put',
      data: data
    })
  }

  // 删除数据
  delete(id, _basicId) {
    let url = this.baseUrl + '/' + id
    if (_basicId) {
      url = this.baseUrl + '/' + _basicId + '/' + id
    }
    return custemRequest({
      url: url,
      method: 'delete'
    })
  }

  // 获取数据详情
  view(id) {
    return custemRequest({
      url: this.baseUrl + '/' + id,
      method: 'get'
    })
  }
  // 获取数据详情
  viewDisplay(id) {
    return custemRequest({
      url: this.baseUrl + '/view/' + id,
      method: 'get'
    })
  }

  // 修改或新增
  save(data) {
    return custemRequest({
      url: this.baseUrl,
      method: 'post',
      data: data
    })
  }
  
  exportData(data,basicId,token){
    let url=this.baseUrl+"/export";
    if(basicId){
      url+="/"+basicId
    }
    let params="";
    for(let value in data){
  		if(data[value]){
  			params+="&"+value+"="+data[value]
  		}
      
    }
    url+="?"+params;
    url+='&Authorization=' + token
    url=window.getLocationUrl()+'/'+url;
    window.open(url)
  }
  
  //
  modifyByUrl(url, data, modelId) {
    let newUrl = this.baseUrl + '/' + url
    if (newUrl.indexOf('?') >= 0) {
      newUrl += '&'
    } else {
      newUrl += '?'
    }
    newUrl += 'modelId=' + modelId
    return custemRequest({
      url: newUrl,
      method: 'post',
      data: data
    })
  }
}



// WEBPACK FOOTER //
// ./src/util/ApiService.js